








































































































































































































































































































































































































































































































































































































































































































import { Component } from 'vue-property-decorator';
import Datepicker from 'vue2-datepicker';
import i18n from '@/services/i18n';
import i18nDb from '@/services/i18n-db';
import * as common from '../common';
import { CollapsiblePane, ComponentBase, NumberInput, Overlay, Pagination } from '../components';
import type { Comp, Dict, Report, Utils } from '../types';


type SortField = 'ID' | 'POS_LEVEL' | 'EXPERIENCE_MIN' | 'EXPERIENCE_MAX' | 'SALARY' | 'POSITION_KIND' | 'BEG_DATE'
    | 'END_DATE' | 'CUR_YEAR';

/**
 * Настройки поиска должностных окладов для госслужащих АГС МВД
 */
interface DictPositionMvdSalarySearchConfig {
    /**
     * Количество элементов на странице
     */
    itemsPerPage: number | null;

    /**
     * Индекс страницы, нумерация с `0`
     */
    page: number | null;

    /**
     * Список ID
     */
    idSet: Array<number> | null;

    /**
     * Стартовое значение - Уровень должности (Обычно 1-17)
     */
    posLevelStartValue: number | null;

    /**
     * Конечное значение - Уровень должности (Обычно 1-17)
     */
    posLevelEndValue: number | null;

    /**
     * Стартовое значение - Стаж - "от" (минимальный)
     */
    experienceMinStartValue: number | null;

    /**
     * Конечное значение - Стаж - "от" (минимальный)
     */
    experienceMinEndValue: number | null;

    /**
     * Стартовое значение - Стаж - "до" (максимальный)
     */
    experienceMaxStartValue: number | null;

    /**
     * Стартовое значение - Стаж - "до" (максимальный)
     */
    experienceMaxEndValue: number | null;

    /**
     * Стартовое значение - Оклад
     */
    salaryStartValue: number | null;

    /**
     * Конечное значение - Оклад
     */
    salaryEndValue: number | null;

    /**
     * Набор значений - Вид должности
     */
    positionKindSet: Array<string> | null;

    /**
     * Стартовое значение - Дата начала действия
     */
    begDateStartValue: Date | null;

    /**
     * Конечное значение - Дата начала действия
     */
    begDateEndValue: Date | null;

    /**
     * Стартовое значение - Дата окончания действия
     */
    endDateStartValue: Date | null;

    /**
     * Конечное значение - Дата окончания действия
     */
    endDateEndValue: Date | null;

    /**
     * Стартовое значение - Базовый год
     */
    curYearStartValue: number | null;

    /**
     * Конечное значение - Базовый год
     */
    curYearEndValue: number | null;

    /**
     * Поле для сортировки
     */
    sortField: SortField | null;

    /**
     * Признак "обратная сортировка" (от большего к меньшему)
     */
    reversedSort: boolean | null;
}


const translates = {
    actions: {
        get add(): string {
            return i18n.choose(
                'Добавить',
                'Қосу',
                'Add',
            );
        },
        get apply(): string {
            return i18n.choose(
                'Применить',
                'Қолдану',
                'Apply',
            );
        },
        get delete(): string {
            return i18n.choose(
                'Удалить',
                'Жою',
                'Delete',
            );
        },
        get edit(): string {
            return i18n.choose(
                'Изменить',
                'Өзгерту',
                'Edit',
            );
        },
        get refresh(): string {
            return i18n.choose(
                'Обновить',
                'Жаңарту',
                'Refresh',
            );
        },
        get save(): string {
            return i18n.choose(
                'Сохранить',
                'Сақтау',
                'Save',
            );
        },
    },
    deletionConfirmationText(id: number): string {
        return i18n.choose(
            () => `Удалить элемент с ID #${id}?`,
            () => `#${id} идентификаторы бар элементті жою керек пе?`,
            () => `Delete element with ID #${id}?`,
        )();
    },
    errors: {
        get cannotDeleteData(): string {
            return i18n.choose(
                'Не удалось удалить данные',
                'Деректерді жою мүмкін болмады',
                'Failed to delete data',
            );
        },
        get cannotLoadData(): string {
            return i18n.choose(
                'Не удалось загрузить данные',
                'Деректерді жүктеу сәтсіз аяқталды',
                'Failed to load data',
            );
        },
        get cannotSaveData(): string {
            return i18n.choose(
                'Не удалось сохранить данные',
                'Деректерді сақтау мүмкін болмады',
                'Failed to save data',
            );
        },
    },
    fields: {
        begDate: {
            get title(): string {
                return i18n.choose(
                    'Период: от (включительно)',
                    'Мерзімі: бастап (қоса алғанда)',
                    'Period: from (inclusive)',
                );
            },
        },
        curYear: {
            get title(): string {
                return i18n.choose(
                    'Базовый год',
                    'Негізгі жыл',
                    'Base year',
                );
            },
        },
        endDate: {
            get title(): string {
                return i18n.choose(
                    'Период: до (не включительно)',
                    'Мерзімі: дейін (қоса есептелмейді)',
                    'Period: up to (not inclusive)',
                );
            },
        },
        experienceMax: {
            get title(): string {
                return i18n.choose(
                    'Стаж - "до" (максимальный)',
                    'Тәжірибе – «дейін» (максималды)',
                    'Experience - "up to" (maximum)',
                );
            },
        },
        experienceMin: {
            get title(): string {
                return i18n.choose(
                    'Стаж - "от" (минимальный)',
                    'Тәжірибе – «бастапқы» (ең аз)',
                    'Experience - "from" (minimum)',
                );
            },
        },
        id: {
            get title(): string {
                return 'ID';
            },
        },
        posLevel: {
            get title(): string {
                return i18n.choose(
                    'Уровень должности',
                    'Жұмыс деңгейі',
                    'Job level',
                );
            },
        },
        positionKind: {
            get title(): string {
                return i18n.choose(
                    'Вид должности',
                    'Позиция түрі',
                    'Type of position',
                );
            },
        },
        salary: {
            get title(): string {
                return i18n.choose(
                    'Оклад',
                    'Жалақы',
                    'Salary',
                );
            },
        },
    },
    filterSort: {
        get title(): string {
            return i18n.choose(
                'Фильтры, сортировка',
                'Сүзгілер, сұрыптау',
                'Filter, sort',
            );
        },
        filter: {
            get copyToMax(): string {
                return i18n.choose(
                    'Скопировать как максимальное значение',
                    'Максималды мән ретінде көшіріңіз',
                    'Copy as maximal value',
                );
            },
            get maxValue(): string {
                return i18n.choose(
                    'Максимальное значение',
                    'Максималды мән',
                    'Maximal value',
                );
            },
            get minValue(): string {
                return i18n.choose(
                    'Минимальное значение',
                    'Ең төменгі мән',
                    'Minimal value',
                );
            },
            get reset(): string {
                return i18n.choose(
                    'Сбросить фильтры',
                    'Сүзгілерді қалпына келтіру',
                    'Reset filters',
                );
            },
            get title(): string {
                return i18n.choose(
                    'Фильтры',
                    'Сүзгілер',
                    'Filters',
                );
            },
            get valueSet(): string {
                return i18n.choose(
                    'Набор значений',
                    'Мәндер жиыны',
                    'Value set',
                );
            },
            get valueSetByComma(): string {
                return i18n.choose(
                    'Набор значений, разделенных запятыми',
                    'Үтірмен бөлінген мәндер жинағы',
                    'Value set separated by commas',
                );
            },
        },
        sort: {
            get field(): string {
                return i18n.choose(
                    'Поле для сортировки',
                    'Сұрыптауға арналған өріс',
                    'Field for sorting',
                );
            },
            get reversedOrder(): string {
                return i18n.choose(
                    'Сортировать в обратном порядке',
                    'Кері ретпен сұрыптау',
                    'Sort in reverse order',
                );
            },
            get title(): string {
                return i18n.choose(
                    'Сортировка',
                    'Сұрыптау',
                    'Sort',
                );
            },
        },
    },
    messages: {
        dataDeleted(id: number): string {
            return i18n.choose(
                () => `Данные успешно удалены, ID = #${id}`,
                () => `Деректер сәтті жойылды, ID = #${id}`,
                () => `Data deleted successfully, ID = #${id}`,
            )();
        },
        dataSaved(id: number): string {
            return i18n.choose(
                () => `Данные успешно сохранены, ID = #${id}`,
                () => `Деректер сәтті сақталды, ID = #${id}`,
                () => `Data saved successfully, ID = #${id}`,
            )();
        },
    },
};

const newSearchConfig = (): DictPositionMvdSalarySearchConfig => {
    return {
        itemsPerPage: null,
        page: null,
        idSet: null,
        posLevelStartValue: null,
        posLevelEndValue: null,
        experienceMinStartValue: null,
        experienceMinEndValue: null,
        experienceMaxStartValue: null,
        experienceMaxEndValue: null,
        salaryStartValue: null,
        salaryEndValue: null,
        positionKindSet: null,
        begDateStartValue: null,
        begDateEndValue: null,
        endDateStartValue: null,
        endDateEndValue: null,
        curYearStartValue: null,
        curYearEndValue: null,
        sortField: null,
        reversedSort: null,
    };
};


@Component({
    components: {
        'date-picker': Datepicker,
        CollapsiblePane,
        NumberInput,
        Overlay,
        Pagination,
    },
})
export default class DictPositionMvdSalaryListPage extends ComponentBase {
    constructor() {
        super('');
    }


    // region Lifecycle
    created() {
        // region Навигация по страницам
        this.$watch('page', () => {
            this.loadIfIdle();
        });
        this.$watch('itemsPerPage', () => {
            this.loadIfIdle();
        });
        // endregion
    }

    protected mounted() {
        this.loadIfIdle();
    }
    // endregion


    // region Util
    // noinspection JSUnusedLocalSymbols
    private translates = translates;

    private formatDate(value: Date | null): string | null {
        if (value === null) {
            return null;
        }
        return i18nDb.translateByTemplate(i18nDb.dateTemplateLong(), value);
    }

    private get fieldOptions(): Array<Comp.DropdownItemDef<SortField | null>> {
        return [
            // Не заполнено
            {
                value: null,
                text: 'Не заполнено',
            },

            // ID
            {
                value: 'ID',
                text: translates.fields.id.title,
            },

            // 'POS_LEVEL'
            {
                value: 'POS_LEVEL',
                text: translates.fields.posLevel.title,
            },

            // 'EXPERIENCE_MIN'
            {
                value: 'EXPERIENCE_MIN',
                text: translates.fields.experienceMin.title,
            },

            // 'EXPERIENCE_MAX'
            {
                value: 'EXPERIENCE_MAX',
                text: translates.fields.experienceMax.title,
            },

            // 'SALARY'
            {
                value: 'SALARY',
                text: translates.fields.salary.title,
            },

            // 'POSITION_KIND'
            {
                value: 'POSITION_KIND',
                text: translates.fields.positionKind.title,
            },

            // 'BEG_DATE'
            {
                value: 'BEG_DATE',
                text: translates.fields.begDate.title,
            },

            // 'END_DATE'
            {
                value: 'END_DATE',
                text: translates.fields.endDate.title,
            },

            // 'CUR_YEAR'
            {
                value: 'CUR_YEAR',
                text: translates.fields.curYear.title,
            },
        ];
    }

    private get positionKindOptions(): Array<Comp.DropdownItemDef<Dict.Position.Kind>> {
        return [
            // 'ADMINISTRATIVE' - Административная
            {
                value: 'ADMINISTRATIVE',
                text: '"ADMINISTRATIVE" - Административная',
            },

            // 'POLITICAL' - Политическая
            {
                value: 'POLITICAL',
                text: '"POLITICAL" - Политическая',
            },

            // 'DEPUTY' - Депутат
            {
                value: 'DEPUTY',
                text: '"DEPUTY" - Депутат',
            },
        ];
    }
    // endregion


    // region Навигация по страницам
    private page = 0;
    private itemsPerPage = 25;
    private totalItems = 0;

    private onItemsPerPageChanged(itemsPerPage: unknown): void {
        this.itemsPerPage = (itemsPerPage as number);
    }
    // endregion


    // region Загрузка, общее
    private loading = false;
    private loadingId: symbol | null = null;
    // endregion


    // region Элементы, фильтрация, сортировка
    // noinspection JSMismatchedCollectionQueryUpdate
    private items: Array<Dict.PositionSalary> = [];

    private filterSortModalVisible = false;
    private filterSortFilterPaneExpanded = false;
    private filterSortSortPaneExpanded = false;

    private filterIdSet: Set<number> = new Set();
    private filterIdSetInput: string = '';
    private filterPosLevelStartValue: number | null = null;
    private filterPosLevelStartValueInput: number | null = null;
    private filterPosLevelEndValue: number | null = null;
    private filterPosLevelEndValueInput: number | null = null;
    private filterExperienceMinStartValue: number | null = null;
    private filterExperienceMinStartValueInput: number | null = null;
    private filterExperienceMinEndValue: number | null = null;
    private filterExperienceMinEndValueInput: number | null = null;
    private filterExperienceMaxStartValue: number | null = null;
    private filterExperienceMaxStartValueInput: number | null = null;
    private filterExperienceMaxEndValue: number | null = null;
    private filterExperienceMaxEndValueInput: number | null = null;
    private filterSalaryStartValue: number | null = null;
    private filterSalaryStartValueInput: number | null = null;
    private filterSalaryEndValue: number | null = null;
    private filterSalaryEndValueInput: number | null = null;
    private filterPositionKindSet: Set<string> = new Set();
    private filterPositionKindSetInput: Set<string> = new Set();
    private filterBegDateStartValue: Date | null = null;
    private filterBegDateStartValueInput: Date | null = null;
    private filterBegDateEndValue: Date | null = null;
    private filterBegDateEndValueInput: Date | null = null;
    private filterEndDateStartValue: Date | null = null;
    private filterEndDateStartValueInput: Date | null = null;
    private filterEndDateEndValue: Date | null = null;
    private filterEndDateEndValueInput: Date | null = null;
    private filterCurYearStartValue: number | null = null;
    private filterCurYearStartValueInput: number | null = null;
    private filterCurYearEndValue: number | null = null;
    private filterCurYearEndValueInput: number | null = null;

    private sortField: SortField | null = 'ID';
    private tmpSortField: SortField | null = null;
    private reversedSort = false;
    private tmpReversedSort = false;

    private get filterIdSetParsed(): Array<number> {
        return this.filterIdSetInput
            .split(',')
            .map(value => parseInt(value.trim(), 10))
            .filter(value => (!isNaN(value)));
    }


    private changeFilterSort() {
        this.filterIdSetInput = [...this.filterIdSet].join(', ');
        this.filterPosLevelStartValueInput = this.filterPosLevelStartValue;
        this.filterPosLevelEndValueInput = this.filterPosLevelEndValue;
        this.filterExperienceMinStartValueInput = this.filterExperienceMinStartValue;
        this.filterExperienceMinEndValueInput = this.filterExperienceMinEndValue;
        this.filterExperienceMaxStartValueInput = this.filterExperienceMaxStartValue;
        this.filterExperienceMaxEndValueInput = this.filterExperienceMaxEndValue;
        this.filterSalaryStartValueInput = this.filterSalaryStartValue;
        this.filterSalaryEndValueInput = this.filterSalaryEndValue;
        this.filterPositionKindSetInput = new Set(this.filterPositionKindSet);
        this.filterBegDateStartValueInput = this.filterBegDateStartValue;
        this.filterBegDateEndValueInput = this.filterBegDateEndValue;
        this.filterEndDateStartValueInput = this.filterEndDateStartValue;
        this.filterEndDateEndValueInput = this.filterEndDateEndValue;
        this.filterCurYearStartValueInput = this.filterCurYearStartValue;
        this.filterCurYearEndValueInput = this.filterCurYearEndValue;

        this.tmpSortField = this.sortField;
        this.tmpReversedSort = this.reversedSort;
        this.filterSortModalVisible = true;
    }

    private resetFilter() {
        this.filterIdSetInput = '';
        this.filterPosLevelStartValueInput = null;
        this.filterPosLevelEndValueInput = null;
        this.filterExperienceMinStartValueInput = null;
        this.filterExperienceMinEndValueInput = null;
        this.filterExperienceMaxStartValueInput = null;
        this.filterExperienceMaxEndValueInput = null;
        this.filterSalaryStartValueInput = null;
        this.filterSalaryEndValueInput = null;
        this.filterPositionKindSetInput = new Set();
        this.filterBegDateStartValueInput = null;
        this.filterBegDateEndValueInput = null;
        this.filterEndDateStartValueInput = null;
        this.filterEndDateEndValueInput = null;
        this.filterCurYearStartValueInput = null;
        this.filterCurYearEndValueInput = null;
    }

    private applyFilterSort() {
        this.filterIdSet = new Set(this.filterIdSetParsed);
        this.filterPosLevelStartValue = this.filterPosLevelStartValueInput;
        this.filterPosLevelEndValue = this.filterPosLevelEndValueInput;
        this.filterExperienceMinStartValue = this.filterExperienceMinStartValueInput;
        this.filterExperienceMinEndValue = this.filterExperienceMinEndValueInput;
        this.filterExperienceMaxStartValue = this.filterExperienceMaxStartValueInput;
        this.filterExperienceMaxEndValue = this.filterExperienceMaxEndValueInput;
        this.filterSalaryStartValue = this.filterSalaryStartValueInput;
        this.filterSalaryEndValue = this.filterSalaryEndValueInput;
        this.filterPositionKindSet = this.filterPositionKindSetInput;
        this.filterBegDateStartValue = this.filterBegDateStartValueInput;
        this.filterBegDateEndValue = this.filterBegDateEndValueInput;
        this.filterEndDateStartValue = this.filterEndDateStartValueInput;
        this.filterEndDateEndValue = this.filterEndDateEndValueInput;
        this.filterCurYearStartValue = this.filterCurYearStartValueInput;
        this.filterCurYearEndValue = this.filterCurYearEndValueInput;

        this.sortField = this.tmpSortField;
        this.reversedSort = this.tmpReversedSort;
        this.loadIfIdle();
    }

    private toggleFilterPositionKind(value: string) {
        const set = new Set(this.filterPositionKindSetInput);
        if (set.has(value)) {
            set.delete(value);
        } else {
            set.add(value);
        }
        this.filterPositionKindSetInput = set;
    }

    private loadIfIdle() {
        if (!this.loading) {
            this.load();
        }
    }

    private load() {
        if (this.loading) {
            console.error('Cannot load data - loading already in progress');
            return;
        }

        const searchConfig = newSearchConfig();
        searchConfig.itemsPerPage = this.itemsPerPage;
        searchConfig.page = this.page;
        searchConfig.sortField = this.sortField;
        searchConfig.reversedSort = this.reversedSort;

        if (this.filterIdSet.size > 0) {
            searchConfig.idSet = [...this.filterIdSet];
        }
        if (this.filterPosLevelStartValue !== null) {
            searchConfig.posLevelStartValue = this.filterPosLevelStartValue;
        }
        if (this.filterPosLevelEndValue !== null) {
            searchConfig.posLevelEndValue = this.filterPosLevelEndValue;
        }
        if (this.filterExperienceMinStartValue !== null) {
            searchConfig.experienceMinStartValue = this.filterExperienceMinStartValue;
        }
        if (this.filterExperienceMinEndValue !== null) {
            searchConfig.experienceMinEndValue = this.filterExperienceMinEndValue;
        }
        if (this.filterExperienceMaxStartValue !== null) {
            searchConfig.experienceMaxStartValue = this.filterExperienceMaxStartValue;
        }
        if (this.filterExperienceMaxEndValue !== null) {
            searchConfig.experienceMaxEndValue = this.filterExperienceMaxEndValue;
        }
        if (this.filterSalaryStartValue != null) {
            searchConfig.salaryStartValue = this.filterSalaryStartValue;
        }
        if (this.filterSalaryEndValue != null) {
            searchConfig.salaryEndValue = this.filterSalaryEndValue;
        }
        if (this.filterPositionKindSet.size > 0) {
            searchConfig.positionKindSet = [...this.filterPositionKindSet];
        }
        if (this.filterBegDateStartValue != null) {
            searchConfig.begDateStartValue = common.convertToKotlinLocalDate(this.filterBegDateStartValue) as unknown as Date;
        }
        if (this.filterBegDateEndValue != null) {
            searchConfig.begDateEndValue = common.convertToKotlinLocalDate(this.filterBegDateEndValue) as unknown as Date;
        }
        if (this.filterEndDateStartValue != null) {
            searchConfig.endDateStartValue = common.convertToKotlinLocalDate(this.filterEndDateStartValue) as unknown as Date;
        }
        if (this.filterEndDateEndValue != null) {
            searchConfig.endDateEndValue = common.convertToKotlinLocalDate(this.filterEndDateEndValue) as unknown as Date;
        }
        if (this.filterCurYearStartValue != null) {
            searchConfig.curYearStartValue = this.filterCurYearStartValue;
        }
        if (this.filterCurYearEndValue != null) {
            searchConfig.curYearEndValue = this.filterCurYearEndValue;
        }

        const loadingId = Symbol('DictPositionMvdSalaryListPage.load');
        this.loading = true;
        this.loadingId = loadingId;
        this.items = [];

        this.request<Utils.PaginationList<Dict.PositionSalary>>(
            {
                url: '/api/budget/staffing_table/dict/dict_position_mvd_salary/list',
                method: 'POST',
                data: searchConfig,
            },
            (data) => {
                if (this.loadingId !== loadingId) {
                    return;
                }

                data.items.forEach((item) => {
                    if (Array.isArray(item.begDate)) {
                        item.begDate = common.convertFromKotlinLocalDate(item.begDate);
                    }
                    if (Array.isArray(item.endDate)) {
                        item.endDate = common.convertFromKotlinLocalDate(item.endDate);
                    }
                });

                this.totalItems = data.itemCount;
                this.page = data.page;
                this.items = data.items;
            },
            () => this.translates.errors.cannotLoadData,
            () => {
                if (this.loadingId !== loadingId) {
                    return;
                }

                this.loadingId = null;
                this.loading = false;
            },
        );
    }
    // endregion


    // region Редактируемый элемент
    private elementChangeModalVisible = false;

    /**
     * ID записи
     *
     * `PRIMARY KEY`
     */
    private changedElementId: number | null = null;

    /**
     * Уровень должности (Обычно 1-17)
     */
    private changedElementPosLevel: number = 1;

    /**
     * Стаж - "от" (минимальный)
     */
    private changedElementExperienceMin: number = 0;

    /**
     * Стаж - "до" (максимальный)
     */
    private changedElementExperienceMax: number = 0;

    /**
     * Оклад
     */
    private changedElementSalary: number = 0;

    /**
     * Вид должности:
     * * "ADMINISTRATIVE" - Административная
     * * "POLITICAL" - Политическая
     * * "DEPUTY" - Депутат
     */
    private changedElementPositionKind: Dict.Position.Kind = 'ADMINISTRATIVE';

    /**
     * Период: от (включительно)
     */
    private changedElementBegDate: Date | null = null;

    /**
     * Период: до (не включительно)
     */
    private changedElementEndDate: Date | null = null;

    /**
     * Базовый год
     */
    private changedElementCurYear: number | null = null;

    private startElementChange(element?: Dict.PositionSalary) {
        if (element === undefined) {
            this.changedElementId = null;
            this.changedElementPosLevel = 1;
            this.changedElementExperienceMin = 0;
            this.changedElementExperienceMax = 0;
            this.changedElementSalary = 0;
            this.changedElementPositionKind = 'ADMINISTRATIVE';
            this.changedElementBegDate = null;
            this.changedElementEndDate = null;
            this.changedElementCurYear = null;
        } else {
            this.changedElementId = element.id;
            this.changedElementPosLevel = element.posLevel;
            this.changedElementExperienceMin = element.experienceMin;
            this.changedElementExperienceMax = element.experienceMax;
            this.changedElementSalary = element.salary;
            this.changedElementPositionKind = (element.positionKind as Dict.Position.Kind);
            this.changedElementBegDate = element.begDate;
            this.changedElementEndDate = element.endDate;
            this.changedElementCurYear = element.curYear;
        }
        this.elementChangeModalVisible = true;
    }

    private saveElement(event: unknown) {
        (event as Event).preventDefault();

        if (this.loading) {
            console.error('Cannot save data - loading already in progress');
            return;
        }

        const data: Dict.PositionMvdSalary_Simplified = {
            id: this.changedElementId,
            posLevel: this.changedElementPosLevel,
            experienceMin: this.changedElementExperienceMin,
            experienceMax: this.changedElementExperienceMax,
            salary: this.changedElementSalary,
            positionKind: this.changedElementPositionKind,
            begDate: this.changedElementBegDate,
            endDate: this.changedElementEndDate,
            curYear: this.changedElementCurYear,
        };
        if (data.begDate !== null) {
            data.begDate = (common.convertToKotlinLocalDate(data.begDate) as unknown as Date);
        }
        if (data.endDate !== null) {
            data.endDate = (common.convertToKotlinLocalDate(data.endDate) as unknown as Date);
        }


        const loadingId = Symbol('DictPositionMvdSalaryListPage.saveElement');
        this.loading = true;
        this.loadingId = loadingId;

        this.request<number>(
            {
                url: '/api/budget/staffing_table/dict/dict_position_mvd_salary',
                method: 'POST',
                data,
            },
            (data) => {
                this.toast(
                    'success',
                    '',
                    this.translates.messages.dataSaved(data),
                );
                this.changedElementId = data;
            },
            () => this.translates.errors.cannotSaveData,
            () => {
                if (this.loadingId !== loadingId) {
                    return;
                }
                this.loadingId = null;
                this.loading = false;
                this.elementChangeModalVisible = false;
                this.load();
            }
        );
    }
    // endregion


    // region Удаление элемента
    private elementDeletionModalVisible = false;
    private removedElementId: number = 0;

    private startElementDeletion(element: Dict.PositionSalary) {
        if (element.id === null) {
            console.error('Cannot delete element - ID is NULL');
            return;
        }

        this.removedElementId = (element.id as number);
        this.elementDeletionModalVisible = true;
    }

    private deleteElement(event: unknown) {
        (event as Event).preventDefault();

        if (this.loading) {
            console.error('Cannot delete element - loading already in progress');
            return;
        }

        const id = this.removedElementId;

        const loadingId = Symbol('DictPositionMvdSalaryListPage.saveElement');
        this.loading = true;
        this.loadingId = loadingId;

        const url = this.prepareUrl(
            '/api/budget/staffing_table/dict/dict_position_mvd_salary',
            [
                ['id', id],
            ],
        );

        this.request<unknown>(
            {
                url,
                method: 'DELETE',
            },
            () => {
                this.toast(
                    'success',
                    '',
                    this.translates.messages.dataDeleted(id),
                );
            },
            () => this.translates.errors.cannotDeleteData,
            () => {
                if (this.loadingId !== loadingId) {
                    return;
                }
                this.loadingId = null;
                this.loading = false;
                this.elementDeletionModalVisible = false;
                this.load();
            }
        );
    }
    // endregion
}
